/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/no-floating-promises */

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Oval } from "react-loader-spinner";
import {
  getFbAccountPermissions,
  getFbAdsAccounts,
  getFbProfile,
  getLongLiveToken,
} from "functions/facebookAds";
import {
  _onSelectAdsItem,
  formatMessageInPlaceholder,
  sweetAlert,
} from "functions/global";
import SelectDropdown from "components/SelectDropdown";
import {
  createFbAsset,
  createFbBusinessManager,
  getFbBusinessManagers,
  getFbPages,
} from "./functions";
import "./styles.css";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import Input from "components/Input";
import AppButton from "components/AppButton";
import TIMEZONES from "./constants/fb-timezone-list.json";
import CURRENCIES from "./constants/currencies.json";
//stepper
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import InstructionStep from "./components/InstructionStep";
import Connected from "./components/Connected";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import AppText from "components/AppText";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { ApiServerPath } from "api_server";

const steps = ["Connect Account", "Confirm Access", "Connected"];

const BUSINESS_MANAGER_CATEGORY = [
  { name: "Advertising", value: "ADVERTISING" },
  { name: "Automotive", value: "AUTOMOTIVE" },
  { name: "Consumer packaged goods", value: "CONSUMER_PACKAGED_GOODS" },
  { name: "Ecommerce", value: "ECOMMERCE" },
  { name: "Education", value: "EDUCATION" },
  { name: "Energy and utilities", value: "ENERGY_AND_UTILITIES" },
  { name: "Entertainment and media", value: "ENTERTAINMENT_AND_MEDIA" },
  { name: "Financial services", value: "FINANCIAL_SERVICES" },
  { name: "Gaming", value: "GAMING" },
  { name: "Government and politics", value: "GOVERNMENT_AND_POLITICS" },
  { name: "Marketing", value: "MARKETING" },
  {
    name: "Organizations and associations",
    value: "ORGANIZATIONS_AND_ASSOCIATIONS",
  },
  { name: "Professional services", value: "PROFESSIONAL_SERVICES" },
  { name: "Retail", value: "RETAIL" },
  { name: "Technology", value: "TECHNOLOGY" },
  { name: "Telecom", value: "TELECOM" },
  { name: "Travel", value: "TRAVEL" },
  { name: "Other", value: "OTHER" },
];

const FbManagerAccess = (props: any) => {
  const connectId = props.connectId;
  const workspaceId = props.workspaceId || "";
  const [activeStep, setActiveStep] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const [errorFromAdmin, setErrorFromAdmin] = useState("");
  const [adminDetails, setAdminDetails] = useState<any>(null);
  const [facebookConnected, setFacebookConnected] = useState<any>(false);
  const [facebookAds, setFacebookAds] = useState<any>(null);
  const [fbAdsAccounts, setFbAdsAccounts] = useState<any>([]);
  const [fbAdsAccountsLoading, setFbAdsAccountsLoading] = useState(false);
  const [selectedFbAccount, setSelectedFbAccount] = useState<any>(null);
  const [fbAccessToken, setFbAccessToken] = useState("");
  const [fbProfile, setFbProfile] = useState<any>(null);
  const [fbPages, setFbPages] = React.useState<any>([]);
  const [fbPagesLoading, setFbPagesLoading] = React.useState(false);
  const [selectedFbPage, setSelectedFbPage] = React.useState<any>(null);
  const [fbPermissions, setFbPermissions] = useState<any[]>([]);
  const [showPagesSelection, setShowPagesSelection] = useState(true);
  const [confirmAccess, setConfirmAccess] = useState(false);

  // create or choose business states
  const [displayNewBusinessDiv, setDisplayNewBusinessDiv] = useState(false);
  const [showCreateBusiness, setShowCreateBusiness] = useState(false);
  const [businessType, setBusinessType] = useState("existing");
  const [createBusinessLoader, setCreateBusinessLoader] = useState(false);
  const [existingBusinessManagers, setExistingBusinessManagers] = useState([]);
  const [selectedBusinessManager, setSelectedBusinessManager] =
    useState<any>(null); // selected existing business manager
  const [businessManagerName, setBusinessManagerName] = useState("");
  const [selectedBusinessManagerCategory, setSelectedBusinessManagerCategory] =
    useState<any>(null);

  //create assets states
  const [showCreateAssets, setShowCreateAssets] = useState(false);
  // const [toggleAssetAccount, setToggleAssetAccount] = useState(false);
  const [selectedTimezone, setSelectedTimezone] = useState(TIMEZONES[7]);
  const [selectedCurrency, setSelectedCurrency] = useState(
    CURRENCIES.find((x) => x.cc === "USD")
  );
  const [assetAdAccountName, setAssetAdAccountName] = useState("");

  useEffect(() => {
    getData();
  }, []);

  const handleBack = () => {
    if (activeStep === 1 && confirmAccess) {
      setConfirmAccess(false);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  ///////////

  const stateClearOnFbReconnect = () => {
    setFbAdsAccounts([]);
    setFbPages([]);
    setFbPermissions([]);
    setSelectedFbPage(null);
    setFbAccessToken("");
    setFacebookAds(null);
  };

  // FB SDK requires a plain function callback — async callbacks throw
  // "Expression is of type asyncfunction, not function".
  const handleFbLoginResponse = async (response: any) => {
    console.log(response, "response");
    if (!response.authResponse) {
      return;
    }

    setFacebookConnected(true);
    setFbAdsAccountsLoading(true);
    stateClearOnFbReconnect();
    setActiveStep(1);

    try {
      const longLiveAccessToken: any = await getLongLiveToken(
        response?.authResponse?.accessToken
      );
      setFbAccessToken(longLiveAccessToken);

      console.log(
        longLiveAccessToken,
        "longLiveAccessTokenlongLiveAccessTokenlongLiveAccessToken"
      );

      let fbProfile: any = await getFbProfile(longLiveAccessToken || "", true);
      setFbProfile(fbProfile);
      console.log(fbProfile, "userNamee=======");

      let fbAccounts: any = await getFbAdsAccounts(
        "debugmessage2",
        longLiveAccessToken
      );

      fbAccounts =
        fbAccounts?.data?.length > 0
          ? fbAccounts?.data.filter(
              (x: any) =>
                x.business &&
                x.business.id !== adminDetails?.businessManagerId
            )
          : [];

      const isMangerPermission =
        (fbAccounts as any)[0]?.user_tasks &&
        (fbAccounts as any)[0]?.user_tasks.includes("MANAGE");
      const isAdvertiserPermission =
        (fbAccounts as any)[0]?.user_tasks &&
        (fbAccounts as any)[0]?.user_tasks.includes("ADVERTISE");

      if (
        (fbAccounts as any).length === 1 &&
        ((fbAccounts as any)[0].id === "act_115263056585426" ||
          (fbAccounts as any)[0].id === "act_427053459589047" ||
          (((fbAccounts as any)[0].account_status !== 2 ||
            (fbAccounts as any)[0].account_status !== 3 ||
            (fbAccounts as any)[0].account_status !== 101) &&
            (!(fbAccounts as any)[0]?.user_tasks ||
              (isMangerPermission
                ? (fbAccounts as any)[0]?.funding_source
                : isAdvertiserPermission))))
      ) {
        console.log(fbAccounts, "in condition");
      }
      setFbAdsAccounts([...fbAccounts]);
      fetchFbPermissions();
      fetchFbPages(longLiveAccessToken, fbAccounts);
      fetchFbBusinessManagers(longLiveAccessToken);
    } catch (error) {
      console.log(error, "error loading facebook accounts");
      setFbAdsAccounts([]);
    } finally {
      setFbAdsAccountsLoading(false);
    }
  };

  const fbAdsLogin = () => {
    try {
      window.FB.login(
        (response: any) => {
          void handleFbLoginResponse(response);
        },
        {
          scope:
            "email,public_profile,pages_manage_ads,pages_manage_metadata,pages_read_engagement,pages_read_user_content,ads_management,read_insights,instagram_basic,leads_retrieval,business_management,catalog_management,pages_manage_posts,pages_show_list,instagram_content_publish,instagram_manage_insights",
        }
      );
    } catch (error) {
      console.log(error, "error login in");
    }
  };

  const onChangePage = (value: any) => {
    setSelectedFbPage(value);
  };

  const fetchFbPermissions = async () => {
    const fbPermissions: any = await getFbAccountPermissions();
    if (fbPermissions?.length) {
      setFbPermissions([...fbPermissions]);
    }
  };

  const getData = async () => {
    try {
      setErrorFromAdmin("");
      setLoading(true);
      const { data } = await axios.post(
        `${ApiServerPath.API_SERVER_BASE_URL}/firebase/get_business_manager`,
        {
          adminId: connectId,
          platform: "FACEBOOK",
          ...(workspaceId ? { workspaceId } : {}),
        }
      );
      console.log(data, "data respp");
      setAdminDetails(data.results.business);
    } catch (e: any) {
      setErrorFromAdmin(e?.response?.data?.results?.error);
      console.log(e, "Eee");
    } finally {
      setLoading(false);
    }
  };

  const fetchFbBusinessManagers = async (tokenFromParam: string) => {
    try {
      const fbManagers: any = await getFbBusinessManagers(tokenFromParam);
      setExistingBusinessManagers(fbManagers);
    } catch (e) {
      setExistingBusinessManagers([]);
    }
  };
  const _createFbBusinessManager = async (tokenFromParam: string) => {
    try {
      setCreateBusinessLoader(true);
      const created: any = await createFbBusinessManager({
        accessToken: tokenFromParam,
        category: selectedBusinessManagerCategory.value,
        name: businessManagerName,
        userId: fbProfile?.id,
      });
      if (created) {
        fetchFbBusinessManagers(fbAccessToken);
        sweetAlert("Business Manager created successfully");
        setShowCreateBusiness(false);
      } else {
        sweetAlert(
          "Something went wrong while creating business manager. please try again"
        );
      }
    } catch (e: any) {
      sweetAlert(
        e?.response?.data?.results?.error ||
        "Something went wrong while creating business manager. please try again"
      );
    } finally {
      setCreateBusinessLoader(false);
    }
  };

  const createFbNewAsset = async (tokenFromParam: string) => {
    try {
      setCreateBusinessLoader(true);
      const created: any = await createFbAsset({
        accessToken: tokenFromParam,
        businessId: selectedBusinessManager.id,
        name: assetAdAccountName,
        timezoneId: selectedTimezone.id?.toString(),
        currency: selectedCurrency?.cc,
      });

      console.log(created, "Created----");
      if (!created.error) {
        sweetAlert("Asset created and selected successfully");
        setConfirmAccess(false);
        setActiveStep(1);
        setDisplayNewBusinessDiv(false);
        setShowPagesSelection(true);
        setShowCreateAssets(false);
        const currentSelectAsset = {
          id: created?.id,
          name: assetAdAccountName,
          business: {
            id: created?.business_id,
            name: selectedBusinessManager?.name,
          },
        };
        const newAccounts = [...fbAdsAccounts, currentSelectAsset];
        console.log(newAccounts, "new");
        setFbAdsAccounts([...newAccounts]);
        setSelectedFbAccount(currentSelectAsset);
      } else {
        sweetAlert(
          created.error ||
          "Something went wrong while creating asset. please try again"
        );
      }
    } catch (e: any) {
      sweetAlert(
        e?.response?.data?.results?.error ||
        "Something went wrong while creating asset. please try again"
      );
    } finally {
      setCreateBusinessLoader(false);
    }
  };

  const fetchFbPages = async (tokenFromParam: string, fbAdsAccounts: any) => {
    try {
      setFbPagesLoading(true);
      const ad_account_business_ids = fbAdsAccounts.map(
        (x: any) => x?.business?.id
      );
      console.log(fbAdsAccounts, "fbAdsAccounts filtered");
      console.log(ad_account_business_ids, "ad_account_business_ids");
      const fbPages: any = await getFbPages(tokenFromParam, connectId, true);
      const filteredPages = fbPages.length
        ? fbPages?.filter((obj: any) => {
          return (
            !obj.hasOwnProperty("business") ||
            (obj.business &&
              ad_account_business_ids.includes(obj.business.id))
          );
        })
        : [];
      console.log(filteredPages, "filteredPages");
      setFbPages([...filteredPages]);
    } catch (e) {
    } finally {
      setFbPagesLoading(false);
    }
  };

  const onSelectAdsItem = async (
    item: any,
    idKey: any,
    idName: any,
    currencyKey: any,
    type: any
  ) => {
    const isSelected = await _onSelectAdsItem(
      item,
      idKey,
      idName,
      currencyKey,
      type,
      null, //workspace id
      true
    );

    if (isSelected) {
      setSelectedFbAccount(item);
      setFacebookAds(isSelected);
    }
  };

  // Render

  const _renderFbPage = () => {
    return fbPagesLoading ? (
      <p className='fb-manager-access-insta-loading-text'>
        <AppText>loading facebook pages</AppText>
      </p>
    ) : (
      <>
        <SelectDropdown
          label='Please select your Facebook page'
          data={fbPages}
          value={selectedFbPage}
          onChange={(value: any) => onChangePage(value)}
          formatOptionLabel={(data: any) => (
            <div>
              <img
                className='ads-platform-page-icon'
                src={data?.picture?.data?.url}
                alt='page-logo'
              />
              <span>{data?.name}</span>
            </div>
          )}
          getOptionLabel={
            (option: any) => option?.name //option?.username
          }
          getOptionValue={(option: any) => option?.id}
        />
      </>
    );
  };

  const renderChooseBusiness = () => {
    return showCreateBusiness ? (
      renderCreateBusiness()
    ) : (
      <div className='fb-manager-access-create-business-container'>
        <p className='m-0 mb-4 text-[1.22rem] font-bold leading-snug tracking-[-0.03em] text-ink'>
          <AppText>Use existing business manager or create a new one</AppText>
        </p>

        <FormControl>
          <RadioGroup
            value={businessType}
            onChange={(e: any) => {
              setBusinessType(e.target.value);
            }}
          >
            <FormControlLabel
              value={"existing"}
              control={<Radio />}
              label={formatMessageInPlaceholder(
                "Choose existing business manager"
              )}
            />

            <SelectDropdown
              containerClassName='selected-business-manager-dropdown'
              value={selectedBusinessManager}
              label='Please select exisiting business manager'
              data={existingBusinessManagers}
              onChange={(value: any) => {
                setSelectedBusinessManager(value);
              }}
              getOptionLabel={(option: any) => option.name}
              getOptionValue={(option: any) => option.id}
            />

            <FormControlLabel
              value={"new"}
              control={<Radio />}
              label={formatMessageInPlaceholder("Create new business manager")}
            />
          </RadioGroup>
        </FormControl>

        <p>
          <AppText
            values={{
              link: (
                <a
                  href={`https://app.advertgenerator.com/?connect_id=${connectId}`}
                >
                  access link
                </a>
              ),
            }}
          >
            {`
            Note: Please make sure business manager hasn't already been created.
            if it has, share the {link}
            with the admin of a business manager`}
          </AppText>
        </p>

        <button
          onClick={() => {
            if (businessType === "new") {
              setShowCreateBusiness(true);
            } else {
              if (selectedBusinessManager) {
                setShowCreateAssets(true);
                setShowCreateBusiness(false);
                setDisplayNewBusinessDiv(false);
              } else {
                sweetAlert("Please select existing business manager");
              }
            }
          }}
          className='inline-flex h-[46px] w-full items-center justify-center rounded-[10px] bg-primary px-5 text-[0.95rem] font-semibold text-white shadow-btn transition hover:bg-primary-hover sm:w-auto'
        >
          <AppText>Continue</AppText>
        </button>

        <p
          onClick={() => {
            setShowPagesSelection(true);
            setDisplayNewBusinessDiv(false);
          }}
          className='go-back-btn'
        >
          <AppText>GO BACK</AppText>
        </p>
      </div>
    );
  };

  const renderCreateBusiness = () => {
    return (
      <div>
        <p className='m-0 mb-4 text-[1.22rem] font-bold leading-snug tracking-[-0.03em] text-ink'>
          <AppText>Create a new business manager</AppText>
        </p>

        <label className='fb-manager-access-input-label'>
          <AppText>New Business Manager Name</AppText>
        </label>
        <Input
          inputChildClassName='create-business-name-input-child'
          className={"create-business-name-input"}
          value={businessManagerName}
          onChange={(e: any) => setBusinessManagerName(e.target.value)}
        />

        <SelectDropdown
          value={selectedBusinessManagerCategory}
          label='Your business industry'
          data={BUSINESS_MANAGER_CATEGORY}
          onChange={(value: any) => {
            setSelectedBusinessManagerCategory(value);
            // fetchFbPages(fbAccessToken);
          }}
          getOptionLabel={(option: any) => option.name}
          getOptionValue={(option: any) => option.value}
        />

        <AppButton
          onClick={() => _createFbBusinessManager(fbAccessToken)}
          className='inline-flex h-[46px] w-full items-center justify-center rounded-[10px] bg-primary px-5 text-[0.95rem] font-semibold text-white shadow-btn transition hover:bg-primary-hover sm:w-auto'
          title='Create new business manager'
          loading={createBusinessLoader}
        />

        <p onClick={() => setShowCreateBusiness(false)} className='go-back-btn'>
          <AppText>GO BACK</AppText>
        </p>
      </div>
    );
  };

  const renderCreateAssets = () => {
    return (
      <div>
        <p className='m-0 mb-4 text-[1.22rem] font-bold leading-snug tracking-[-0.03em] text-ink'>
          <AppText>Create new Facebook Assets</AppText>
        </p>

        <p>
          <AppText
            values={{ managerName: <b>{selectedBusinessManager?.name}</b> }}
          >
            {`These assets will be created within the {managerName} business
            manager`}
          </AppText>
        </p>

        <p>
          <AppText>
            Select and name the new ad account you would like to create below:
          </AppText>
        </p>

        <div className='fb-manager-assets-switch-container'>
          {/* <AppSwitch
            checked={toggleAssetAccount}
            onChange={(e) => setToggleAssetAccount(e.target.checked)}
          /> */}

          <div className='fb-manager-assets-switch-subcontainer'>
            <p className='fb-manager-assets-switch-title'>
              <AppText>Ad Account</AppText>
            </p>

            <>
              <Input
                placeholder='asset account name'
                className={"create-business-name-input"}
                value={assetAdAccountName}
                onChange={(e: any) => setAssetAdAccountName(e.target.value)}
              />

              <SelectDropdown
                value={selectedCurrency}
                label='Currency'
                data={CURRENCIES}
                onChange={(value: any) => {
                  setSelectedCurrency(value);
                }}
                getOptionLabel={(option: any) => option.name}
                getOptionValue={(option: any) => option.cc}
              />

              <SelectDropdown
                defaultValue={selectedTimezone}
                label='Timezone'
                data={TIMEZONES}
                onChange={(value: any) => {
                  setSelectedTimezone(value);
                }}
                getOptionLabel={(option: any) => option.name}
                getOptionValue={(option: any) => option.code}
              />
            </>
          </div>
        </div>

        <AppButton
          onClick={() => createFbNewAsset(fbAccessToken)}
          className='inline-flex h-[46px] w-full items-center justify-center rounded-[10px] bg-primary px-5 text-[0.95rem] font-semibold text-white shadow-btn transition hover:bg-primary-hover sm:w-auto'
          title='Continue and create new ad account'
          loading={createBusinessLoader}
        />

        <p
          onClick={() => {
            setDisplayNewBusinessDiv(true);
            setShowCreateAssets(false);
          }}
          className='go-back-btn'
        >
          <AppText>GO BACK</AppText>
        </p>
      </div>
    );
  };

  const handleGrantAccess = () => {
    if (!selectedFbAccount) {
      sweetAlert("Please select ad account");
    } else {
      setConfirmAccess(true);
    }
  };

  const stepSubtitle =
    activeStep === 0
      ? "Sign in with Facebook so we can find your ad accounts and pages."
      : activeStep === 1
        ? confirmAccess
          ? "Follow the steps below to finish sharing partner access."
          : "Choose the ad account and page you want to share access to."
        : "You're all set — partner access has been granted.";

  const renderAccountAndPageSelection = () => {
    return (
      <div className='rounded-xl border border-line bg-surface p-5 shadow-sm'>
        <div className='mb-4 flex items-start gap-3.5'>
          <div className='flex h-11 w-11 shrink-0 items-center justify-center rounded-[11px] border border-line bg-muted'>
            <img
              src='images/global/meta.png'
              alt=''
              className='h-6 w-6 object-contain'
            />
          </div>
          <div>
            <p className='m-0 mb-1 text-[1.02rem] font-bold tracking-[-0.015em] text-ink'>
              <AppText>Confirm which assets to share</AppText>
            </p>
            <p className='m-0 text-[0.875rem] leading-relaxed text-ink-secondary'>
              <AppText>
                Select an ad account you manage. You can also create new assets
                if needed.
              </AppText>
            </p>
          </div>
        </div>
        <p
          onClick={() => {
            setShowPagesSelection(false);
            setDisplayNewBusinessDiv(true);
          }}
          className='mb-3.5 cursor-pointer text-[0.875rem] font-semibold text-ink-link no-underline hover:underline'
        >
          <AppText>
            Create a new Business Manager, Ad Account or other assets
          </AppText>
        </p>
        {fbAdsAccountsLoading ? (
          <div className='flex min-h-[120px] flex-col items-center justify-center gap-3 py-6 text-[0.875rem] text-ink-secondary'>
            <Oval
              height={32}
              width={32}
              color={'var(--color-primary)'}
              visible={true}
              ariaLabel='loading-ad-accounts'
              secondaryColor='var(--text-grey)'
              strokeWidth={2}
              strokeWidthSecondary={2}
            />
            <AppText>Loading your ad accounts...</AppText>
          </div>
        ) : fbAdsAccounts?.length > 0 ? (
          <div>
            <SelectDropdown
              value={selectedFbAccount}
              label='Please select Ad account'
              data={fbAdsAccounts}
              onChange={(value: any) => {
                onSelectAdsItem(value, idKey, idName, currencyKey, "FACEBOOK");
              }}
              getOptionLabel={(option: any) => option.name}
              getOptionValue={(option: any) => option.id}
            />

            {_renderFbPage()}

            <AppButton
              style={{ marginTop: 20 }}
              title='Confirm Access'
              onClick={() => handleGrantAccess()}
              className='fb-lb-access-btn !h-[46px] !w-full !rounded-[10px] !bg-primary !px-5 !font-semibold !text-white !shadow-btn'
            />
          </div>
        ) : (
          <div className='rounded-[10px] border border-danger/30 bg-[#fef2f2] px-3.5 py-3 text-[0.875rem] leading-relaxed text-danger'>
            <AppText>
              You do not have access to ad accounts managed by Business Manager.
              Either the Business Manager associated with your ad account is not
              yours, or the Business Manager's admin is the same as your admin.
            </AppText>
          </div>
        )}
      </div>
    );
  };

  const renderConnectFacebook = () => {
    return (
      <div className='rounded-xl border border-line bg-surface p-5 shadow-sm'>
        <div className='mb-4 flex items-start gap-3.5'>
          <div className='flex h-11 w-11 shrink-0 items-center justify-center rounded-[11px] border border-line bg-muted'>
            <img
              src='images/global/facebook.png'
              alt=''
              className='h-6 w-6 object-contain'
            />
          </div>
          <div>
            <p className='m-0 mb-1 text-[1.02rem] font-bold tracking-[-0.015em] text-ink'>
              <AppText>Connect your Facebook Account</AppText>
            </p>
            <p className='m-0 text-[0.875rem] leading-relaxed text-ink-secondary'>
              <AppText>
                Use a Facebook login that has access to the Business Manager
                assets you want to share.
              </AppText>
            </p>
          </div>
        </div>
        {facebookConnected && (
          <div className='mb-3.5'>
            <span className='inline-flex items-center gap-1.5 rounded-full border border-success/20 bg-success-soft px-3 py-1.5 text-[0.76rem] font-semibold text-success'>
              <FontAwesomeIcon icon={faCheckCircle as IconProp} />
              <AppText>Facebook connected</AppText>
            </span>
          </div>
        )}
        <button
          type='button'
          className='inline-flex h-[46px] w-full items-center justify-center rounded-[10px] bg-primary px-5 text-[0.95rem] font-semibold text-white shadow-btn transition hover:bg-primary-hover'
          onClick={fbAdsLogin}
        >
          <AppText>
            {facebookConnected ? "Reconnect Facebook" : "Connect Facebook"}
          </AppText>
        </button>
        <p className='mt-3 mb-0 text-[0.75rem] leading-snug text-ink-muted'>
          <AppText>
            You stay in control — partner access can be reviewed in Meta Business
            Manager.
          </AppText>
        </p>
      </div>
    );
  };

  const progressWidth = `${((activeStep + 1) / steps.length) * 100}%`;

  const renderStepper = () => {
    return (
      <>
        <div className='mb-5 rounded-xl border border-line bg-muted px-4 py-3.5'>
          <Stepper activeStep={activeStep}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div
            className='mt-3 h-1 overflow-hidden rounded-full bg-line'
            aria-hidden
          >
            <div
              className='h-full rounded-full bg-gradient-to-r from-primary to-[#5b8cff] transition-all duration-300'
              style={{ width: progressWidth }}
            />
          </div>
        </div>
        <div>
          {activeStep !== 2 && !confirmAccess && (
            <div className='mb-5 rounded-xl border border-primary-text/10 bg-primary-soft p-4'>
              <p className='m-0 mb-3.5 text-[0.72rem] font-bold uppercase tracking-[0.06em] text-ink-muted'>
                <AppText>Request Details</AppText>
              </p>
              <div className='grid grid-cols-1 gap-3.5 sm:grid-cols-2'>
                <div className='min-w-0'>
                  <span className='mb-1 block text-[0.72rem] font-semibold tracking-[0.02em] text-ink-muted'>
                    <AppText>Meta Business Manager</AppText>
                  </span>
                  <span className='block break-words text-[0.92rem] font-semibold leading-snug text-ink'>
                    {adminDetails?.businessManagerName}{" "}
                    {`(${adminDetails?.businessManagerId})`}
                  </span>
                </div>
                <div className='min-w-0'>
                  <span className='mb-1 block text-[0.72rem] font-semibold tracking-[0.02em] text-ink-muted'>
                    <AppText>Access Level</AppText>
                  </span>
                  <span className='block text-[0.92rem] font-semibold leading-snug text-ink'>
                    <AppText>Manage</AppText>
                  </span>
                </div>
              </div>
            </div>
          )}
          {activeStep === 0 && renderConnectFacebook()}
          {activeStep === 1 ? (
            confirmAccess ? (
              <InstructionStep
                selectedFbPage={selectedFbPage}
                connectId={connectId}
                workspaceId={workspaceId}
                fbAccessToken={fbAccessToken}
                selectedFbAccount={selectedFbAccount}
                adminDetails={adminDetails}
                setActiveStep={setActiveStep}
                setConfirmAccess={setConfirmAccess}
                onBack={handleBack}
              />
            ) : (
              renderAccountAndPageSelection()
            )
          ) : null}
          {activeStep === 2 && (
            <Connected
              selectedFbAccount={selectedFbAccount}
              adminDetails={adminDetails}
            />
          )}
        </div>

        {activeStep !== 2 && (
          <div className='mt-5 flex flex-wrap items-center justify-between gap-3 border-t border-line-muted bg-muted/70 px-4 py-3.5 sm:px-8'>
            <Button
              color='inherit'
              disabled={activeStep === 0}
              onClick={handleBack}
            >
              <AppText>Back</AppText>
            </Button>
            <Box sx={{ flex: "1 1 auto" }} />
            {facebookConnected && activeStep === 0 && (
              <Button onClick={() => setActiveStep(1)}>
                <AppText>Continue</AppText>
              </Button>
            )}
          </div>
        )}
      </>
    );
  };

  const idKey = "facebookAds.accountId";
  const idName = "facebookAds.accountName";
  const currencyKey = "facebookAds.currencyCode";

  if (loading) {
    return (
      <div className='box-border flex min-h-screen w-full max-w-full min-w-0 flex-col items-center overflow-x-hidden bg-[radial-gradient(1200px_420px_at_50%_-80px,rgba(15,96,253,0.07),transparent_60%),var(--bg-page)] px-3 pb-7 pt-16 text-ink sm:px-5 sm:pt-20'>
        <div className='flex min-h-[280px] flex-col items-center justify-center gap-3 text-[0.9rem] text-ink-secondary'>
          <Oval
            height={40}
            width={40}
            color={"var(--color-primary)"}
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor='var(--text-grey)'
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
          <AppText>Loading request details...</AppText>
        </div>
      </div>
    );
  }

  return (
    <div className='box-border flex min-h-screen w-full max-w-full min-w-0 flex-col items-center overflow-x-hidden bg-[radial-gradient(1200px_420px_at_50%_-80px,rgba(15,96,253,0.07),transparent_60%),var(--bg-page)] px-3 pb-7 pt-16 text-ink sm:px-5 sm:pt-20'>
      {adminDetails ? (
        <div className='flex w-full max-w-[680px] flex-col gap-5'>
          <div className='lb-card w-full overflow-visible rounded-card border border-line bg-surface p-0 shadow-card'>
            <div className='px-4 pb-2 pt-6 sm:px-8 sm:pt-7'>
              {!displayNewBusinessDiv && !showCreateAssets && (
                <>
                  <div className='mb-5 flex items-center justify-between gap-3'>
                    <div className='flex min-w-0 items-center gap-2.5'>
                      <div className='flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-[10px] border border-line bg-surface shadow-sm'>
                        <img
                          src='images/global/meta.png'
                          alt=''
                          className='h-[22px] w-[22px] object-contain'
                        />
                      </div>
                      <div className='min-w-0'>
                        <p className='m-0 text-[0.92rem] font-bold leading-tight text-ink'>
                          <AppText>Meta Link Bridge</AppText>
                        </p>
                        <p className='m-0 hidden text-[0.75rem] text-ink-muted sm:block'>
                          <AppText>Secure partner access request</AppText>
                        </p>
                      </div>
                    </div>
                    <span className='inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-line bg-muted px-2.5 py-1.5 text-[0.72rem] font-bold tracking-[0.02em] text-ink-secondary'>
                      <AppText>Step</AppText>{" "}
                      <strong className='text-primary-text'>
                        {activeStep + 1}/{steps.length}
                      </strong>
                    </span>
                  </div>

                  <div className='mb-5'>
                    <p className='m-0 mb-2 text-[1.22rem] font-bold leading-snug tracking-[-0.03em] text-ink sm:text-[1.45rem]'>
                      <AppText
                        values={{
                          managerName: adminDetails?.businessManagerName,
                        }}
                      >
                        {`{managerName} is requesting Partner Access to your Facebook Assets`}
                      </AppText>
                    </p>
                    <p className='m-0 max-w-[540px] text-[0.875rem] leading-relaxed text-ink-secondary sm:text-[0.925rem]'>
                      <AppText>{stepSubtitle}</AppText>
                    </p>
                  </div>
                </>
              )}

              {showPagesSelection && renderStepper()}
              {showCreateAssets && renderCreateAssets()}
              {displayNewBusinessDiv && renderChooseBusiness()}
            </div>
          </div>
          <video
            src='https://firebasestorage.googleapis.com/v0/b/plai-v3.appspot.com/o/ad-account-access.mp4?alt=media&token=03bcd6de-d8a9-47b9-8c0c-44459df9af8a'
            controls={true}
            className='block w-full rounded-card border border-line bg-muted shadow-sm'
          />
        </div>
      ) : (
        <div className='max-w-[420px] rounded-card border border-line bg-surface px-6 py-12 text-center shadow-card'>
          <FontAwesomeIcon
            className='mb-3 text-[42px] text-danger'
            icon={faTriangleExclamation as IconProp}
          />
          <p className='m-0 text-[0.95rem] leading-relaxed text-ink-secondary'>
            {errorFromAdmin}
          </p>
        </div>
      )}
    </div>
  );
};

export default FbManagerAccess;
